<template>

	<div class="index-container">
		<!-- <el-row>
			<div style="margin-top: 20px;border-top: 1px solid gainsboro; padding-top: 10px;">
				<el-form ref="form" :model="form">
					<el-form-item label="商场名称">
						<el-select collapse-tags @change="mallSelect" v-model="form.mallIds" placeholder="全部" multiple>
							<el-option v-for="item in mallList" :label="item.name" :value="item.id"
								:key="item.id"></el-option>
						</el-select>
					</el-form-item>
				</el-form>
			</div>
		</el-row> -->
		<el-row>
			<div class="title-box">
				<div class="title-left"></div>
				<div class="title">业态数据排行</div>
			</div>
			<div v-loading="ytLoading" class="charts1 height500" ref="ytChart"></div>
			<div v-loading="ytLoading" v-if="ytEmpty" class="empty1 empty">
				<span class="empty-title">业态数据排行</span>
				<span class="empty-content">未产生交易，暂无数据...</span>
			</div>
		</el-row>
		<el-row>
			<div class="title-box">
				<div class="title-left"></div>
				<div class="title">店铺数据排行</div>
			</div>
			<div v-loading="dpLoading" class="charts1 height500" ref="dpChart"></div>
			<div v-loading="dpLoading" v-if="dpEmpty" class="empty1 empty">
				<span class="empty-title">店铺数据排行</span>
				<span class="empty-content">未产生交易，暂无数据...</span>
			</div>
		</el-row>
	</div>
</template>

<script>
	import {
		api_getConfig
	} from "@/api/common";
	import {
		api_getDashboardStoreDataChart
	} from "@/api/home";

	import * as echarts from 'echarts';


	export default {
		name: 'DataRanking',
		props: {
			mallIds: {
				required: true,
				type: Array
			}
		},
		data() {
			return {
				dpEmpty: false,
				ytEmpty: false,
				ytLoading: false,
				dpLoading: false,
				ytChart: null,
				dpChart: null,
				form: {
					mallIds: []
				},
				mallList: [],

				ytOption: {
					grid: {
						x: 50,
						y: 20,
						x2: 10,
						y2: 60,
					},
					legend: {
						bottom: 0,
					},
					dataZoom: [{
						type: 'inside',
						start: 0,
						end: 30,
					}],
					tooltip: {},
					xAxis: {
						name: '',
						type: 'category',
					},
					yAxis: {
						name: '',
						type: 'value',
						splitNumber: 8,
						splitLine: {
							show: true,
							lineStyle: {
								color: '#ccc',
								type: 'dashed'
							}
						}
					},
					series: [{
						name: '交易金额',
						type: 'bar',
						label: {
							show: true,
							position: 'top'
						},
						itemStyle: {
							color: 'rgba(55, 117, 255, 1)'
						}
					}]
				},
				dpOption: {
					grid: {
						x: 50,
						y: 20,
						x2: 10,
						y2: 60,
					},
					legend: {
						bottom: 0,
					},
					dataZoom: [{
						type: 'inside',
						start: 0,
						end: 30,
					}],
					xAxis: {
						name: '',
						type: 'category',
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'shadow'
						}
					},
					yAxis: {
						name: '',
						type: 'value',
						splitNumber: 8,
						splitLine: {
							show: true,
							lineStyle: {
								color: '#ccc',
								type: 'dashed'
							}
						}
					},
					series: [{
						name: '交易金额',
						type: 'bar',
						label: {
							show: true,
							position: 'top'
						},
						itemStyle: {
							color: 'rgba(55, 117, 255, 1)'
						}
					}]
				}
			}
		},
		watch: {
			mallIds: {
				handler(newVal, oldVal) {
					if (newVal) {
						//this.mallIds = newVal;
						this.getYtData()
						this.getDpData()

					}
				},
				immediate: true,
				deep: true
			},

		},
		created() {
			//this.getConfig()

		},
		beforeDestroy() {},
		mounted() {
			window.onresize = () => {
				return (() => {
					try {
						this.ytChart = echarts.init(this.$refs.ytChart)
						console.log('yt 对象：', this.ytChart)
						this.$refs.ytChart.removeAttribute('_echarts_instance_')
						this.ytChart.setOption(this.ytOption)

					} catch (error) {
						console.log('季错：1', error)
					}

					try {
						this.dpChart = echarts.init(this.$refs.dpChart)
						console.log('dp 对象：', this.dpChart)
						this.$refs.dpChart.removeAttribute('_echarts_instance_')
						this.dpChart.setOption(this.dpOption)

					} catch (error) {
						console.log('季错：21', error)
					}
				})()
			}
		},
		methods: {
			mallSelect() {
				this.getYtData()
				this.getDpData()
			},
			// 获取config
			async getConfig() {
				const {
					storeThreeLevel = [], mall = []
				} = await api_getConfig(['mall'])
				this.mallList = mall // 商场

				if (mall && mall.length > 0) {
					this.mallIds.push(mall[0].id)
					/* this.getYtData()
					this.getDpData() */
				}
			},
			/**
			 * 业态数据
			 */
			async getYtData() {
				try {
					if (!this.mallIds || this.mallIds.length <= 0)
						return;
					this.ytLoading = true
					let data = await api_getDashboardStoreDataChart({
						mallIds: this.mallIds,
						storeType: 1
					})
					

					if (data && data.length > 0) {
						this.ytOption.xAxis.data = data.map((item) => {
							return item.name
						})
						this.ytOption.series[0].data = data.map((item) => {
							return item.amount
						})
					}

					this.ytEmpty = false
					this.ytLoading = false

					try {
						this.$refs.ytChart.removeAttribute('_echarts_instance_')

					} catch (error) {
						console.log('当前表', error)
					}

					this.ytChart = echarts.init(this.$refs.ytChart)
					this.ytChart.setOption(this.ytOption)
				} catch (e) {
					console.log(e)
				}

			},
			/**
			 * 店铺数据
			 */
			async getDpData() {
				try {
					if (!this.mallIds || this.mallIds.length <= 0)
						return;

					this.dpLoading = true
					let data = await api_getDashboardStoreDataChart({
						mallIds: this.mallIds,
						storeType: 2
					})
					console.log('这是数据显示：',data)

					if (data && data.length > 0) {
						this.dpOption.xAxis.data = data.map((item) => {
							return item.name
						})
						this.dpOption.series[0].data = data.map((item) => {
							return item.amount
						})
					}
					this.dpLoading = false


					try {
						this.$refs.dpChart.removeAttribute('_echarts_instance_')
					} catch (error) {
						console.log('当前表222', error)
					}

					this.dpChart = echarts.init(this.$refs.dpChart)
					this.dpChart.setOption(this.dpOption)
				} catch (e) {
					console.log(e)
				}
			},
		},
	}
</script>

<style lang="scss" scoped>
	.index-container {
		padding: 0 20px;
		padding-top: 5px;
		padding-bottom: 20px;

		.title-box {
			margin-top: 30px;
			margin-bottom: 30px;
			display: flex;
			align-items: center;

			.title-left {
				width: 5px;
				height: 25px;
				background: #05C8AF;
				border-radius: 2px;
			}

			.title {
				font-size: 18px;
				font-weight: 600;
				color: #333333;
				margin-left: 10px;
			}
		}

		.finance.first {
			// border-top: 0;
			margin-bottom: 20px;
		}

		.finance {
			height: 100px;
			border-top: 1px solid #dcdfe6;
			border-bottom: 1px solid #dcdfe6;
			box-sizing: border-box;
			display: flex;
			// min-width: 1150px;
		}

		.financeBig {
			min-width: 1223px;
		}

		.finance-div {
			// min-width: 1160px;
			overflow: auto;
		}

		*::-webkit-scrollbar {
			/*滚动条整体样式*/
			width: 4px;
			/*高宽分别对应横竖滚动条的尺寸*/
			height: 5px;
		}

		*::-webkit-scrollbar-thumb {
			/*滚动条里面小方块*/
			border-radius: 10px;
			box-shadow: inset 0 0 5px rgba(97, 184, 179, 0.1);
			background: #dcdfe6;
		}

		*::-webkit-scrollbar-track {
			/*滚动条里面轨道*/
			box-shadow: inset 0 0 5px rgba(87, 175, 187, 0.1);
			border-radius: 10px;
			background: #fafafa;
		}

		.dataItem {
			// border-top: 1px solid #dcdfe6;
			// border-bottom: 1px solid #dcdfe6;
			width: 250px;
			flex-shrink: 0;
			display: flex;
			align-items: center;

			img {
				width: 40px;
				height: 40px;
				margin-left: 30px;
			}

			.dataItem-content {
				margin-left: 10px;
				width: 174px;

				.dataItem-title {
					font-size: 12px;
					color: #666666;
					margin: 0;
					margin-bottom: 10px;
				}

				.dataItem-value {
					font-size: 20px;
					font-weight: 500;
					color: #333333;
					margin: 0;

					span {
						font-size: 12px;
						font-weight: 400;
						color: #666666;
						margin-left: 10px;
					}
				}
			}

			::v-deep {
				.el-divider--vertical {
					height: 70px;
				}
			}
		}

		.radio-change {
			text-align: right;
		}

		.charts1 {
			width: 100%;
			height: 300px;
		}

		.height500 {
			height: 500px;
		}

		.charts2 {
			height: 0;
			position: relative;
		}

		.tipsB {
			font-size: 13px;
			color: #999;
		}

		.empty {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;

			.empty-title {
				font-size: 14px;
				color: #333333;
				display: block;
			}

			.empty-content {
				font-size: 18px;
				font-weight: 400;
				color: #999999;
				line-height: 280px;
				display: block;
				text-align: center;
			}

			height: 300px;
		}

		.empty1 {
			height: 500px;
			top: 20px;

			.empty-content {
				line-height: 500px;
			}
		}
	}
</style>